<template>

  <ChartNormal 
  size="12" 
  offset="0" 
  title="Received" 
  chart="column" 
  chartType="Received" 
  :isCity="false" 
  :withDate="true" 
  :withFinancial="false" />
  
</template>

<script>
import ChartNormal from "../../components/chart/chartNormal";

export default {
  name: "End Of Life",
  components: {
    ChartNormal,
  }
};
</script>